import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import React, {useEffect, useState} from "react";
import {Fade} from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Equipment from "./EquipmentModel";
import Tooltip from "@material-ui/core/Tooltip";
import LoadingOverlay from 'react-loading-overlay';
import DialogTitle from "@material-ui/core/DialogTitle";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Fade direction="down" ref={ref} {...props} />;
});
const useStyles = makeStyles(theme => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1)
        },
    },
    chip: {
        margin: 4,
    },
    externalIdHolder: {
        border: '1px solid rgba(224, 224, 224, 1)',
        margin: 5,
        maxHeight: 80,
        overflowY: 'scroll'
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    externalIdLabel: {
        color: 'rgba(0, 0, 0, 0.54)',
        padding: 0,
        fontSize: '.75rem',
        fontWeight: 400,
        lineHeight: 1,
        marginLeft: 7
    }
}));

const isComplete = (equipment) => {
    return equipment.name && equipment.type;
};


export default function EquipmentEditor({saving, isNew, open, onCancel, onSubmit, inputResource}) {
    const [equipment, setEquipment] = useState(inputResource),
        [submitDisabled, setSubmitDisabled] = useState(!isComplete(equipment)),
        classes = useStyles();

    const getOnChange = field => event => {
        event.persist();
        setEquipment(equipment => {
            equipment[field] = event.target.value;
            return new Equipment(equipment.toJson());
        });
    };

    useEffect(() => {
        setSubmitDisabled(!isComplete(equipment));
    }, [equipment]);

    return <Dialog fullWidth={true}
                   open={open}
                   maxWidth={'sm'}
                   TransitionComponent={Transition}
                   onClose={onCancel}
                   style={{zIndex: 1150}}
    ><LoadingOverlay
        active={saving}
        spinner
        text={'Saving...'}>
        <DialogTitle>{equipment.displayName === '' && isNew ? 'New Equipment' : equipment.displayName }</DialogTitle>
        <DialogContent>
            <form className={classes.root} noValidate autoComplete="off">
                <div style={{display: 'flex', flexDirection: 'column'}}>
                    <TextField id="equipment-id" label="ID"
                               disabled
                               value={isNew ? 'New Equipment' : equipment.equipmentId}/>
                    <TextField id="equipment-name" label="Name" onChange={getOnChange('name')}
                               required
                               value={equipment.name ? equipment.name : ''}/>
                    <TextField id="equipment-display-name" label="Display Name"
                               onChange={getOnChange('displayName')}
                               helperText={'This value will be shown as the equipment name in all other views.'}
                               value={equipment.displayName ? equipment.displayName : ''}/>
                    <TextField id="equipment-type" label="Type" onChange={getOnChange('type')}
                               required
                               value={equipment.type ? equipment.type : ''}/>
                    <TextField id="equipment-display-type" label="Display Type"
                               onChange={getOnChange('displayType')}
                               helperText={'This value will be shown as the equipment type in all other views.'}
                               value={equipment.displayType ? equipment.displayType : ''}/>
                    <TextField id="equipment-external-id" label="External Id"
                               onChange={getOnChange('externalId')}
                               helperText={'Id used to track in your system'}
                               value={equipment.externalId ? equipment.externalId : ''}/>
                </div>
            </form>
        </DialogContent>
        <DialogActions>
            <Tooltip title={submitDisabled ? 'Please enter equipment name and equipment type' : null}>
                <span>
                    <Button onClick={() => {
                        onSubmit(equipment)
                    }} disabled={submitDisabled} color="secondary">Submit</Button>
                </span>
            </Tooltip>
            <Button onClick={onCancel} color="primary">Cancel</Button>
        </DialogActions>
    </LoadingOverlay>
    </Dialog>;

}
